module.exports = __webpack_public_path__ + "static/media/Prev-alt.51426e1a.svg";